import React, { useState, useEffect } from 'react';
import { get_fum_securities } from '../../services/common';
import moment from 'moment';

const SecuritiesSecurities = ({ fumId }) => {
  const [securities, setSecurities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (fumId) {
      getFumSecurities();
    }
  }, [fumId]);

  const getFumSecurities = async () => {
    try {
       
    const systemToken = localStorage.getItem('systemToken') || "";
  
    //   const localData = JSON.parse(localStorage.getItem('caprock-local') || '{}');
    //   console.log(localData);
    //   const userToken = localData['access-token'];
      
      const response = await get_fum_securities(systemToken, fumId);
      
      if (response.success === 200) {
        const securitiesData = response.securities || [];
        
        const processedSecurities = securitiesData.map(security => {
          const processedSecurity = {
            ...security,
            investor_visible: 0,
            investment_publish_date: moment(security.investment_publish_date).format('DD MMM, YYYY'),
          };

          // Process investment type
          switch (security.inv_type) {
            case 4:
              processedSecurity.inv_type = 'In-House Strategies';
              break;
            case 5:
              processedSecurity.inv_type = 'Outsourced Strategies';
              break;
            case 6:
              processedSecurity.inv_type = 'Private Label';
              break;
            case 7:
              processedSecurity.inv_type = 'Managed Investment Schemes';
              break;
            default:
              processedSecurity.inv_type = '';
          }

          // Process investors
          if (typeof security.investors !== 'undefined') {
            processedSecurity.investors = security.investors.map(investor => ({
              ...investor,
              investor_request_date: moment(investor.investor_request_date).format('DD/MM/YYYY'),
              investor_inv_amount: parseFloat(investor.investor_inv_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }));
          }

          return processedSecurity;
        });

        setSecurities(processedSecurities);
      } else {
        setSecurities([]);
      }
    } catch (error) {
      console.error('Error fetching fum securities:', error);
      setSecurities([]);
    } finally {
      setLoading(false);
    }
  };

  const toggleInvestorVisible = (status, securityId) => {
    setSecurities(prevSecurities => 
      prevSecurities.map(security => 
        security.security_id === securityId 
          ? { ...security, investor_visible: status }
          : security
      )
    );
  };

  if (loading) {
    return (
      <div className="w-full m-0">
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full m-0">
      {securities.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500">No securities found</p>
        </div>
      ) : (
        securities.map((security) => (
          <div key={security.security_id} className="w-full mt-3">
            <div className="mb-2 flex justify-between items-center">
              <b className="text-sm md:text-base lg:text-lg" style={{ fontSize: 'clamp(12px, 2rem, 15px)' }}>
                {security.security_name}
              </b>
              {typeof security.investors !== 'undefined' && (
                <div className="float-right">
                  <img 
                    onClick={() => toggleInvestorVisible(security.investor_visible === 0 ? 1 : 0, security.security_id)}
                    src="/src/assets/caprock/images/down-arrow.svg"
                    alt={security.investor_visible === 0 ? "Expand" : "Collapse"}
                    style={{ 
                      cursor: 'pointer', 
                      height: '13px', 
                      width: '13px', 
                      margin: '4px 0 0 0' 
                    }}
                  />
                </div>
              )}
            </div>

            {/* First Row */}
            <div className="grid grid-cols-12 gap-0">
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  No Of Subscribers
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.no_of_subscribers}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Investment
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.inv_name}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Yield
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.security_yield}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Minimum Investment
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.currency_symbol} {typeof security.inv_amount !== 'undefined' && security.inv_amount !== '' 
                    ? security.inv_amount 
                    : 0}
                </p>
              </div>
            </div>

            {/* Second Row */}
            <div className="grid grid-cols-12 gap-0 mt-2">
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Currency
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.currency_name}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Investment Period
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.inv_term} {typeof security.inv_term_type !== 'undefined' && security.inv_term_type === 1 
                    ? 'Month' 
                    : 'Year'}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Coupon
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.inv_coupon}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Subscription
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.inv_subscription} {typeof security.inv_subscription_other !== 'undefined' 
                    ? security.inv_subscription_other 
                    : '-'}
                </p>
              </div>
            </div>

            {/* Third Row */}
            <div className="grid grid-cols-12 gap-0 mt-2">
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Investment Pub. Date
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.investment_publish_date}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Rank
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.inv_rank}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Type
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.inv_type}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Location
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.location}
                </p>
              </div>
            </div>

            {/* Fourth Row */}
            <div className="grid grid-cols-12 gap-0 mt-2">
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Asset Type
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.inv_asset_type}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Asset Sector
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.inv_asset_sector}
                </p>
              </div>
              <div className="col-span-3 p-0 border border-gray-300">
                <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
                  Fees
                </p>
                <p className="m-0 p-2 bg-white text-center text-sm">
                  {security.security_fees}
                </p>
              </div>
            </div>

            {/* Investors Table */}
            {security.investor_visible === 1 && typeof security.investors !== 'undefined' && (
              <div className="mt-4">
                <div className="w-full overflow-x-auto">
                  <table className="min-w-full table-auto border-collapse border border-gray-300">
                    <thead className="bg-gray-800">
                      <tr>
                        <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-white uppercase tracking-wider" style={{ width: '20%' }}>Date</th>
                        <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-white uppercase tracking-wider" style={{ width: '50%' }}>Investor Name</th>
                        <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-white uppercase tracking-wider" style={{ width: '30%' }}>Invested Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {security.investors.map((investor) => (
                        <tr key={investor.investor_id} className="hover:bg-gray-50">
                          <td className="border border-gray-300 px-2 py-1 text-sm" style={{ width: '20%' }}>
                            {investor.investor_request_date}
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm" style={{ width: '50%' }}>
                            {typeof investor.user_type !== 'undefined' && investor.user_type === 1 
                              ? `${investor.user_first_name} ${investor.user_last_name}`
                              : investor.user_company_name}
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm" style={{ width: '30%' }}>
                            {typeof investor.investor_inv_amount !== 'undefined' 
                              ? `${investor.currency_symbol} ${investor.investor_inv_amount}`
                              : ''}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default SecuritiesSecurities;
